import React from "react";
import StripeSplitFields from "./StripeSplitFields";

const AddPayment = () => {
  return <StripeSplitFields />;
};

export default AddPayment;
